var sixpad = sixpad || {};
window.modelCarousel = {
    modelData: [],
    modelId: 1,
};

$(window).on('load', function () {

    anchor = function (_target, _duration = 1) {
        gsap.to(window, { ease: 'power2', duration: _duration, scrollTo: { y: _target, offsetY: 0 } });
    }


    var tabID = 1;
    tabToggle = function () {
        $('.sec-product-tab-menu-item').removeClass('selected');
        $('.sec-product-tab-contents-item').removeClass('selected');

        if (tabID == 1) {
            tabID = 2;
            $('.sec-product-tab-menu-item.index').addClass('selected');
            $('.sec-product-tab-contents-index').addClass('selected');
        } else {
            tabID = 1;
            $('.sec-product-tab-menu-item.set').addClass('selected');
            $('.sec-product-tab-contents-set').addClass('selected');
        }

        anchor('.sec-product', 0.8);
    }


    btnMouseEvent = function () {
        var $link = document.getElementsByClassName('sec-product-tab-menu-item');
        for (var i = 0; i < $link.length; i++) {
            $link[i].addEventListener("mouseenter", function () { this.classList.add('hover'); })
            $link[i].addEventListener("mouseleave", function () { this.classList.remove('hover'); })
            $link[i].addEventListener("touchstart", function () { this.classList.add('hover'); })
            $link[i].addEventListener("touchend", function () { this.classList.remove('hover'); })
        }
        document.getElementsByTagName('body')[0].addEventListener("touchend", function () { $('.sec-product-tab-menu-item').removeClass('hover'); });

        $('.sec-product-tab-menu-item').on('click', function () {
            tabToggle();
        })
    }

    btnMouseEvent();
    var adc_model_wear = new AccordionContent('.model_wear', 0);



    //Swiper
    if ($('body').hasClass('subscription') || $('body').hasClass('apply')) {

        //POWERSUIT SET
        if ($('#carousel-cart-powersuit_set').length) {
            var powersuit_set_swiper = new setSwiper("#carousel-cart-powersuit_set", 1, 0, "fade");
        }


        //POWERSUIT TOP
        if ($('#carousel-cart-powersuit_top').length) {
            var powersuit_top_swiper = new setSwiper("#carousel-cart-powersuit_top", 1, 0, "fade");
        }



        //POWERSUIT BOTTOM
        if ($('#carousel-cart-powersuit_bottom').length) {
            var powersuit_bottom_swiper = new setSwiper("#carousel-cart-powersuit_bottom", 1, 0, "fade");
        }



        //The Bike
        if ($('#carousel-cart-bike').length) {
            var bike_swiper = new setSwiper("#carousel-cart-bike", 1, 0, "fade");
        }



        //The Bike EX
        if ($('#carousel-cart-bike_ex').length) {
            var bike_ex_swiper = new setSwiper("#carousel-cart-bike_ex", 1, 0, "fade");
        }



        //MODEL WEAR

        if ($('#model_wear').length) {
            $('.model_desc-item').each(function (i) {
                modelCarousel.modelData.push(
                    {
                        wearing: $(this).find('.wearing_size').html(),
                        model: $(this).find('.model_size').html(),
                    }
                );
            });
            modelCarousel.setSwiper();
        }
    }



    //tabmenu fixed
    if ($('.c-sec-product-tab').length) {
        var $tabmenu = $('.c-sec-product-tab');
        var $tabmenu_content = $('.c-sec-product-tab .sec-product-tab-contents');
        var $subtabmenu = $('.sec-product-tab-menu.sub');

        window.addEventListener('scroll', function () {
            var scroll_top = $window.scrollTop();
            var win_height = $window.height();
            var tabmenu_top = $tabmenu_content.offset().top;
            var tabmenu_height = $tabmenu.height();

            if (scroll_top > tabmenu_top && scroll_top < tabmenu_top + tabmenu_height) {
                $subtabmenu.addClass('is-show');
            } else {
                $subtabmenu.removeClass('is-show');
            }
        });
    }

    $('#select-size').on('change', function() {
        if($(this).val() !== '') {
            $(this).closest('.select-set').addClass('selected');
        }
    });

});

modelCarousel.setSwiper = () => {
    if(typeof modelCarousel.swiper !== 'undefined') {
        modelCarousel.swiper.destroy();
    }
    const modelSwiper = new setSwiper('.carousel-model_wear', 'auto', 35);
    modelCarousel.swiper = modelSwiper.getswiper;

    modelCarousel.swiper.on('slideChangeTransitionEnd', function () {
        var thisId = $('.carousel-model_wear').find('.swiper-slide-active').data('person');
        if (thisId != modelCarousel.modelId) {
            modelCarousel.modelId = thisId;
            writing(thisId);
        }
    });

    const writing = function (n) {
        $('.model_wear-desc').children('.wearing_detail').html(modelCarousel.modelData[n - 1].wearing);
        $('.model_wear-desc').children('.model_detail').html(modelCarousel.modelData[n - 1].model);
    }
    writing(modelCarousel.modelId);
};

//validation
var subscription_validation = function () {

    const radio_gender = $('.gender-select input:radio:checked').val().toLowerCase();

    const men_radio_size_top = $('#product-powersuit-size-set.men').find('[name="top-size"]:checked').val();
    const men_radio_size_bottom = $('#product-powersuit-size-set.men').find('[name="bottom-size"]:checked').val();
    const women_radio_size_top = $('#product-powersuit-size-set.women').find('[name="top-size"]:checked').val();
    const women_radio_size_bottom = $('#product-powersuit-size-set.women').find('[name="bottom-size"]:checked').val();


    if (!radio_gender) {
        $('.gender-select').addClass('is-error');
        return;
    } else {
        $('.gender-select').removeClass('is-error');
    }

    if (radio_gender == "men") {
        if (!men_radio_size_top) {
            $('#product-powersuit-size-set.men .product-powersuit-size-top .size-select').addClass('is-error');
        } else {
            $('#product-powersuit-size-set.men .product-powersuit-size-top .size-select').removeClass('is-error');
        }
        if (!men_radio_size_bottom) {
            $('#product-powersuit-size-set.men .product-powersuit-size-bottom .size-select').addClass('is-error');
        } else {
            $('#product-powersuit-size-set.men .product-powersuit-size-bottom .size-select').removeClass('is-error');
        }

        if (!men_radio_size_top || !men_radio_size_bottom) {
            return;
        }
    }

    if (radio_gender == "women") {
        if (!women_radio_size_top) {
            $('#product-powersuit-size-set.women .product-powersuit-size-top .size-select').addClass('is-error');
        } else {
            $('#product-powersuit-size-set.women .product-powersuit-size-top .size-select').removeClass('is-error');
        }
        if (!women_radio_size_bottom) {
            $('#product-powersuit-size-set.women .product-powersuit-size-bottom .size-select').addClass('is-error');
        } else {
            $('#product-powersuit-size-set.women .product-powersuit-size-bottom .size-select').removeClass('is-error');
        }

        if (!women_radio_size_top || !women_radio_size_bottom) {
            return;
        }
    }
}

class setSwiper {
    constructor(target, slidesPerView = "auto", spaceBetween = "0", effect = false, speed = 400) {
        this._target = target;
        this._carousel_swiper;
        this._slidesPerView = slidesPerView;
        this._spaceBetween = spaceBetween;
        this._effect = effect;
        this._speed = speed;
        this.init();
    }
    init() {
        var totalNum = $(this._target).find('li').length;
        $(this._target).find('.c-carousel-count__total').html(getdoubleDigestNumer(totalNum));

        this._carousel_swiper = new Swiper(this._target + " .swiper-container", {
            setWrapperSize: true,
            slidesPerView: this._slidesPerView,
            spaceBetween: this._spaceBetween,
            slidesOffsetAfter: 0,
            effect: this._effect,
            loop: true,
            speed: this._speed,
            navigation: {
                nextEl: this._target + " .c-carousel-navi-next",
                prevEl: this._target + " .c-carousel-navi-prev",
            }
        });
        let $current_target = $(this._target).find('.c-carousel-count__current');
        this._carousel_swiper.on('slideChange', function () {
            var curremtNum = getdoubleDigestNumer(this.realIndex + 1);
            $current_target.html(curremtNum);
        });
        if (totalNum == 1) { $(this._target).find('#swiper-navigation').addClass('is-hide'); }

    }

    get getswiper() {
        return this._carousel_swiper;
    }
}


class AccordionContent {
    /*
    adc-btn
    adc-content
    adc-inner
    */
    constructor(target, defaltHeight = 0, spMode = false) {
        this._target = target;
        this._$btn = $(target).find('.adc-btn');
        this._$content;
        this._$contentItem = $(this._target).find('.adc-content');
        this._$inner;
        this._$innerHeight;
        this._defaltHeight = defaltHeight;
        this._spMode = spMode;


        if (this._defaltHeight != 0) {
            this._$contentItem.each((i) => {
                $(this._target).eq(i).find('.adc-content').css('height', this._defaltHeight);
            });
        }


        this._$btn.each((i) => {
            this._$btn[i].addEventListener('click', (e) => {

                this._$content = $(e.target).parent().find('.adc-content');
                this._$innerHeight = this._$content.find('.adc-inner').outerHeight();

                if (!this._$content.hasClass('is-open')) {
                    this._$btn.addClass('is-open');
                    this._$content.addClass('is-open');
                    this._$content.css('height', this._$innerHeight);
                } else {
                    this._$btn.removeClass('is-open');
                    this._$content.removeClass('is-open');
                    if (this._defaltHeight == 0) {
                        this._$content.css('height', '');
                    } else {
                        this._$content.css('height', this._defaltHeight);
                    }
                }

                return false;

            });
        });


        window.addEventListener('resize', () => {
            this._$contentItem.each((i) => {
                if (this._$contentItem.eq(i).hasClass('is-open')) {
                    this._$contentItem.eq(i).css('height', this._$contentItem.eq(i).find('.adc-inner').outerHeight());
                } else {
                    if (this._defaltHeight != 0) {
                        this._$contentItem.eq(i).css('height', this._defaltHeight);
                    }
                }
            });
        });
    }

    set defaltHeight(defaltHeight) {
        this._defaltHeight = defaltHeight;
    }

}



/*!
 * ScrollToPlugin 3.10.3
 * https://greensock.com
 * 
 * @license Copyright 2022, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self).window = e.window || {}) }(this, function (e) { "use strict"; function k() { return "undefined" != typeof window } function l() { return u || k() && (u = window.gsap) && u.registerPlugin && u } function m(e) { return "string" == typeof e } function n(e) { return "function" == typeof e } function o(e, t) { var o = "x" === t ? "Width" : "Height", n = "scroll" + o, r = "client" + o; return e === T || e === i || e === c ? Math.max(i[n], c[n]) - (T["inner" + o] || i[r] || c[r]) : e[n] - e["offset" + o] } function p(e, t) { var o = "scroll" + ("x" === t ? "Left" : "Top"); return e === T && (null != e.pageXOffset ? o = "page" + t.toUpperCase() + "Offset" : e = null != i[o] ? i : c), function () { return e[o] } } function r(e, t) { if (!(e = f(e)[0]) || !e.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || { x: 0, y: 0 }; var o = e.getBoundingClientRect(), n = !t || t === T || t === c, r = n ? { top: i.clientTop - (T.pageYOffset || i.scrollTop || c.scrollTop || 0), left: i.clientLeft - (T.pageXOffset || i.scrollLeft || c.scrollLeft || 0) } : t.getBoundingClientRect(), l = { x: o.left - r.left, y: o.top - r.top }; return !n && t && (l.x += p(t, "x")(), l.y += p(t, "y")()), l } function s(e, t, n, l, i) { return isNaN(e) || "object" == typeof e ? m(e) && "=" === e.charAt(1) ? parseFloat(e.substr(2)) * ("-" === e.charAt(0) ? -1 : 1) + l - i : "max" === e ? o(t, n) - i : Math.min(o(t, n), r(e, t)[n] - i) : parseFloat(e) - i } function t() { u = l(), k() && u && document.body && (T = window, c = document.body, i = document.documentElement, f = u.utils.toArray, u.config({ autoKillThreshold: 7 }), v = u.config(), a = 1) } var u, a, T, i, c, f, v, y = { version: "3.10.3", name: "scrollTo", rawVars: 1, register: function register(e) { u = e, t() }, init: function init(e, o, r, l, i) { a || t(); var c = this, f = u.getProperty(e, "scrollSnapType"); c.isWin = e === T, c.target = e, c.tween = r, o = function _clean(e, t, o, r) { if (n(e) && (e = e(t, o, r)), "object" != typeof e) return m(e) && "max" !== e && "=" !== e.charAt(1) ? { x: e, y: e } : { y: e }; if (e.nodeType) return { y: e, x: e }; var l, i = {}; for (l in e) i[l] = "onAutoKill" !== l && n(e[l]) ? e[l](t, o, r) : e[l]; return i }(o, l, e, i), c.vars = o, c.autoKill = !!o.autoKill, c.getX = p(e, "x"), c.getY = p(e, "y"), c.x = c.xPrev = c.getX(), c.y = c.yPrev = c.getY(), f && "none" !== f && (c.snap = 1, c.snapInline = e.style.scrollSnapType, e.style.scrollSnapType = "none"), null != o.x ? (c.add(c, "x", c.x, s(o.x, e, "x", c.x, o.offsetX || 0), l, i), c._props.push("scrollTo_x")) : c.skipX = 1, null != o.y ? (c.add(c, "y", c.y, s(o.y, e, "y", c.y, o.offsetY || 0), l, i), c._props.push("scrollTo_y")) : c.skipY = 1 }, render: function render(e, t) { for (var n, r, l, i, s, p = t._pt, c = t.target, f = t.tween, u = t.autoKill, a = t.xPrev, y = t.yPrev, d = t.isWin, x = t.snap, g = t.snapInline; p;)p.r(e, p.d), p = p._next; n = d || !t.skipX ? t.getX() : a, l = (r = d || !t.skipY ? t.getY() : y) - y, i = n - a, s = v.autoKillThreshold, t.x < 0 && (t.x = 0), t.y < 0 && (t.y = 0), u && (!t.skipX && (s < i || i < -s) && n < o(c, "x") && (t.skipX = 1), !t.skipY && (s < l || l < -s) && r < o(c, "y") && (t.skipY = 1), t.skipX && t.skipY && (f.kill(), t.vars.onAutoKill && t.vars.onAutoKill.apply(f, t.vars.onAutoKillParams || []))), d ? T.scrollTo(t.skipX ? n : t.x, t.skipY ? r : t.y) : (t.skipY || (c.scrollTop = t.y), t.skipX || (c.scrollLeft = t.x)), !x || 1 !== e && 0 !== e || (r = c.scrollTop, n = c.scrollLeft, g ? c.style.scrollSnapType = g : c.style.removeProperty("scroll-snap-type"), c.scrollTop = r + 1, c.scrollLeft = n + 1, c.scrollTop = r, c.scrollLeft = n), t.xPrev = t.x, t.yPrev = t.y }, kill: function kill(e) { var t = "scrollTo" === e; !t && "scrollTo_x" !== e || (this.skipX = 1), !t && "scrollTo_y" !== e || (this.skipY = 1) } }; y.max = o, y.getOffset = r, y.buildGetter = p, l() && u.registerPlugin(y), e.ScrollToPlugin = y, e.default = y; if (typeof (window) === "undefined" || window !== e) { Object.defineProperty(e, "__esModule", { value: !0 }) } else { delete e.default } });



